<form id="cashCollectedForm" #cashCollectedForm="ngForm">
  <p-dialog header="Charge Card" [(visible)]="showDialog" [modal]="true" [blockScroll]="false" (onHide)="cancel()" [style]="{width: '480px'}">
    @if (!isLoading) {
      <app-customer-billing-profile [customer]="customer" style="z-index: 11111" (billingProfileEntryModalClosed)="refreshBilling()"></app-customer-billing-profile>
    }
    <div>
      Work Order Total: {{workOrder.workOrderTotal | currency: 'USD' : 'symbol'}}
      <br/>
      Cash/Check Collected: {{workOrder.cashCollected | currency: 'USD' : 'symbol'}}
      <br/>
      Amount Due: {{workOrder.amountDue | currency: 'USD' : 'symbol'}}
    </div>
    <ng-template pTemplate="footer">
      <app-loading-swirly [isLoading]="isLoading"></app-loading-swirly>
      @if (showNoCC) {
        <span class="fine-print">There is no credit card on file, edit the billing info above to add a card.</span>
      }
      <p-button type="button" (click)="chargeCard()" label="Charge Card" [disabled]="disabled" severity="info"></p-button>
      <p-button type="button" (click)="cancel()" label="Cancel" severity="warn"></p-button>
    </ng-template>
  </p-dialog>
</form>
